"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var PasswordInput_1 = __importDefault(require("../../PasswordInput"));
var Input_1 = __importDefault(require("../../Input"));
var Heading_1 = __importDefault(require("../../Heading"));
var PasswordResetForm = function (_a) {
    var onClick = _a.onClick;
    var _b = react_1.useState(null), value = _b[0], setValue = _b[1];
    return (react_1.default.createElement("div", { className: "lg:h-screen  w-full flex flex-wrap" },
        react_1.default.createElement("div", { className: "h-screen w-full lg:h-full lg:w-1/2 flex justify-center items-center" },
            react_1.default.createElement("div", { className: "max-w-xl px-12 lg:px-32" },
                react_1.default.createElement("div", { className: "w-full max-w-xs" },
                    react_1.default.createElement("div", { className: " mt-8 mr-24 p-8 rounded w-full mb-6" },
                        react_1.default.createElement(Heading_1.default, { label: 'Reset your password' }),
                        react_1.default.createElement("div", { className: "my-5" },
                            react_1.default.createElement(Input_1.default, { name: 'Email', placeholder: "Email", onChange: function (e) {
                                    setValue(e.currentTarget.value);
                                }, value: value || '' })),
                        react_1.default.createElement("div", { className: "my-5" },
                            react_1.default.createElement(PasswordInput_1.default, { name: 'password', placeholder: "password", onChange: function (e) {
                                    setValue(e.currentTarget.value);
                                }, value: value || '' })),
                        react_1.default.createElement("div", { className: "my-5" },
                            react_1.default.createElement(PasswordInput_1.default, { name: "Confirm password", placeholder: "Confirm password", onChange: function (e) {
                                    setValue(e.currentTarget.value);
                                }, value: value || '' })),
                        react_1.default.createElement("div", { className: "my-5" }))))),
        react_1.default.createElement("div", { className: "h-screen w-full lg:h-full lg:w-1/2 relative" },
            react_1.default.createElement("div", { className: "w-full h-full bg-blue" }))));
};
exports.default = PasswordResetForm;
//# sourceMappingURL=index.js.map